export interface ContactStatesSkillObject {
    SkillID: number;
    SkillName: string;
    ContactCounts: number[];
    Total?: number;
}

export enum EStateName {
    WithAgent = "With Agent", // green
    OutQueue = "OutQueue", // teal
    InQueue = "InQueue", // orange
    PreQueue = "PreQueue", // yellow
    PostQueue = "PostQueue", // blue
}